type MerchantRouteLoader = () => Promise<unknown>;

const routeLoaders: Record<string, MerchantRouteLoader> = {
  dashboard: () => import("../../../features/dashboard/pages/DashboardPage"),
  "design-generator": () => import("../../../features/design-generator/pages/DesignStudioPage"),
  designs: () => import("../../../features/designs/pages/DesignLibraryPage"),
  "rip-jobs": () => import("../../../features/print-files/pages/RipJobsPage"),
  mockups: () => import("../../../features/mockups/pages/MockupWorkspace"),
  templates: () => import("../../../features/templates/pages/TemplatesPage"),
  wizard: () => import("../../../features/admin/wizard/pages/WizardHubPage"),
  apps: () => import("../../../features/apps/pages/AppsHubPage"),
  "app-heuravo": () => import("../../../features/apps/pages/AppDetailPage"),
  orders: () => import("../../../features/admin/orders/pages/OrdersPage"),
  statistics: () => import("../../../features/admin/statistics/pages/StatisticsPage"),
  advertising: () => import("../../../features/admin/advertising/pages/AdvertisingPage"),
  returns: () => import("../../../features/admin/orders/pages/ReturnsPage"),
  messages: () => import("../../../features/admin/messages/pages/MessagesPage"),
  invoices: () => import("../../../features/admin/orders/pages/InvoicesPage"),
  articles: () => import("../../../features/admin/articles/pages/ArticlesPage"),
  customers: () => import("../../../features/admin/orders/pages/CustomersPage"),
  downloads: () => import("../../../features/jobs/pages/DownloadsPage"),
  setup: () => import("../../../features/admin/setup/pages/SetupHubPage"),
  settings: () => import("../../../features/settings/pages/UserSettingsPage"),
};

const prefetchedRoutes = new Set<string>();

export function prefetchMerchantRoute(id: string) {
  const load = routeLoaders[id];
  if (!load || prefetchedRoutes.has(id)) return;

  prefetchedRoutes.add(id);
  void load().catch(() => prefetchedRoutes.delete(id));
}
